import Layout from "../components/Layout";
import PageHeader from "../components/PageHeader";

const TermsPage = () => {
  return (
    <Layout>
      <PageHeader
        title="Pogoji uporabe"
        description="Pogoji uporabe naših storitev."
      />
      
      <div className="container mx-auto py-12 md:py-16 px-6 md:px-8">
        <div className="max-w-3xl mx-auto prose prose-lg">
          <h2 className="text-2xl font-bold mb-6">Pogoji uporabe</h2>
          
          <p>Spodaj so navedeni pogoji uporabe za storitve in spletno stran klinike Dr. Danijela Novaka. Z uporabo naše spletne strani in storitev se strinjate s temi pogoji uporabe.</p>
          
          <h3 className="text-xl font-bold mt-8 mb-4">1. Splošne določbe</h3>
          <p>Ta spletna stran je v lasti in upravljanju klinike Dr. Danijela Novaka. Z dostopom do te spletne strani in njeno uporabo se strinjate, da boste upoštevali te pogoje uporabe in vse veljavne zakone in predpise ter da ste odgovorni za skladnost z vsemi veljavnimi lokalnimi zakoni.</p>
          
          <h3 className="text-xl font-bold mt-8 mb-4">2. Natančnost informacij</h3>
          <p>Vsebina te spletne strani je zgolj informativne narave. Prizadevamo si za točnost in ažurnost vseh podatkov, vendar ne moremo jamčiti za natančnost, popolnost ali zanesljivost katerih koli informacij na tej spletni strani. Uporaba informacij s te spletne strani je na lastno odgovornost.</p>
          
          <h3 className="text-xl font-bold mt-8 mb-4">3. Medicinski nasveti</h3>
          <p>Informacije, navedene na tej spletni strani, ne predstavljajo medicinskega nasveta in ne morejo nadomestiti individualne konzultacije z zdravnikom. Za specifične medicinske nasvete ali diagnoze se obrnite neposredno na naše zdravnike.</p>
          <p>Vsak kirurški ali nekirurški poseg vključuje tveganja, ki jih je treba oceniti v osebnem posvetu s kvalificiranim zdravnikom.</p>
          
          <h3 className="text-xl font-bold mt-8 mb-4">4. Vsebina</h3>
          <p>Vse vsebine na tej spletni strani, vključno z besedilom, grafikami, logotipi, slikami, avdio posnetki, digitalnimi prenosi, podatki in programsko opremo, so last klinike Dr. Danijela Novaka ali njenih dobaviteljev vsebine in so zaščitene z mednarodnimi zakoni o avtorskih pravicah.</p>
          
          <h3 className="text-xl font-bold mt-8 mb-4">5. Povezave na druge spletne strani</h3>
          <p>Naša spletna stran lahko vsebuje povezave na spletne strani v lasti ali upravljanju tretjih oseb. Nimamo nadzora nad temi spletnimi stranmi in nismo odgovorni za njihovo vsebino ali njihove prakse zasebnosti. Vključitev katerih koli povezav ne pomeni, da jih potrjujemo.</p>
          
          <h3 className="text-xl font-bold mt-8 mb-4">6. Omejitev odgovornosti</h3>
          <p>Klinika Dr. Danijela Novaka ne bo v nobenem primeru odgovorna za kakršno koli škodo, vključno z, vendar ne omejeno na, neposredno, posredno, naključno, kazensko ali posledično škodo, ki izhaja iz uporabe ali nezmožnosti uporabe te spletne strani ali storitev, tudi če je bila klinika Dr. Danijela Novaka obveščena o možnosti takšne škode.</p>
          
          <h3 className="text-xl font-bold mt-8 mb-4">7. Rezervacije in posvetovanja</h3>
          <p>Rezervacije posvetov preko spletne strani ali telefona ne predstavljajo zavezujočega dogovora o izvedbi posega. Vse storitve in posegi so predmet medicinskega pregleda in individualnega posveta s kvalificiranim zdravnikom, ki oceni primernost posega za posameznika.</p>
          <p>Pridržujemo si pravico, da zavrnemo izvedbo storitve ali posega, če se ugotovi, da ni primeren za posameznega pacienta zaradi medicinskih ali drugih razlogov.</p>
          
          <h3 className="text-xl font-bold mt-8 mb-4">8. Plačilni pogoji</h3>
          <p>Plačilne obveznosti, vračila in odpovedi so določeni v individualni pogodbi o storitvah, ki jo podpišete pred izvedbo storitve ali posega. Prosimo, da se za podrobnosti o plačilnih pogojih obrnete neposredno na našo kliniko.</p>
          
          <h3 className="text-xl font-bold mt-8 mb-4">9. Spremembe pogojev uporabe</h3>
          <p>Klinika Dr. Danijela Novaka si pridržuje pravico, da kadar koli spremeni te pogoje uporabe. Spremembe bodo objavljene na tej strani. Z nadaljevanjem uporabe naših storitev po objavi sprememb se šteje, da sprejemate in se strinjate s spremembami.</p>
          
          <h3 className="text-xl font-bold mt-8 mb-4">10. Veljavno pravo</h3>
          <p>Ti pogoji uporabe in vaš odnos s kliniko Dr. Danijela Novaka se urejajo in razlagajo v skladu z zakoni Republike Slovenije, brez upoštevanja določb o koliziji zakonov.</p>
          
          <h3 className="text-xl font-bold mt-8 mb-4">11. Kontaktni podatki</h3>
          <p>Če imate kakršna koli vprašanja v zvezi s temi pogoji uporabe, nas kontaktirajte:</p>
          <p>
            Dr. Danijel Novak<br />
            Rožna ulica 7<br />
            1000 Ljubljana<br />
            Slovenija<br />
            E-pošta: info@danijelnovak.si<br />
            Telefon: +386 41 123 456
          </p>
          
          <p className="mt-8 text-gray-600 italic">Zadnja posodobitev: 12. maj, 2024</p>
        </div>
      </div>
    </Layout>
  );
};

export default TermsPage;